import CompetitionModuleData from 'app/components/competitionModule/models/CompetitionModuleData';
import {InfiniteData} from '@tanstack/react-query';
import DistrictCompetitionsResponse from 'app/components/competitionModule/models/DistrictCompetitionsResponse';
import AdSlotModel from 'app/components/ads/AdSlotModel';
import {AdUnit} from 'app/components/ads/AdUnit';
import {AdLayout} from 'app/components/ads/AdLayout';

type AdSlotConfig = {
  index: number;
  adLayout: AdLayout;
  adUnit: AdUnit;
};

export default class InfiniteCompetitionModules {
  readonly competitionModules: CompetitionModuleData[];

  constructor(data: InfiniteData<DistrictCompetitionsResponse> | undefined) {
    this.competitionModules = data ? data.pages.map(page => page.data).flat() : [];
  }

  private hasMoreThanThreeEntries(): boolean {
    return this.competitionModules.length > 3;
  }

  hasModules(): boolean {
    return this.competitionModules.length > 0;
  }

  getFirstCompetitionModule(): CompetitionModuleData | undefined {
    return this.competitionModules[0];
  }

  getSecondAndThirdCompetitionModule(): CompetitionModuleData[] | undefined {
    if (this.competitionModules.length < 2) {
      return undefined;
    } else if (this.competitionModules.length === 2) {
      return [this.competitionModules[1]];
    }
    return [this.competitionModules[1], this.competitionModules[2]];
  }

  getInfiniteList(): (CompetitionModuleData | AdSlotModel)[] {
    if (!this.hasMoreThanThreeEntries()) {
      return [];
    }

    const sliceAt = Math.min(this.competitionModules.length, 3);
    const moduleList = this.competitionModules.slice(sliceAt);
    return this.addAdSlotsToInfiniteList(moduleList);
  }

  private addAdSlotsToInfiniteList(list: CompetitionModuleData[]): (CompetitionModuleData | AdSlotModel)[] {
    const adSlots: AdSlotConfig[] = [
      {index: 0, adLayout: 'mobile', adUnit: AdUnit.Rectangle_1},
      {index: 1, adLayout: 'desktop', adUnit: AdUnit.Superbanner_3},
      {index: 4, adLayout: 'mobile', adUnit: AdUnit.Content_2},
      {index: 7, adLayout: 'mobile', adUnit: AdUnit.Rectangle_2},
    ];

    const listWithAdSlots: (CompetitionModuleData | AdSlotModel)[] = [...list];

    adSlots.forEach(slot => {
      if (listWithAdSlots.length > slot.index) {
        listWithAdSlots.splice(slot.index, 0, new AdSlotModel({adLayout: slot.adLayout, adUnit: slot.adUnit}));
      }
    });

    return listWithAdSlots;
  }
}
